module.exports = __webpack_public_path__ + "static/img/logo-white.f546173.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-white.svg
// module id = 421
// module chunks = 1